export default ({ request }) => ({
  ecomEvgPlanOrderListApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanOrderSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/save',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },

  ecomEvgPlanOrderDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanOrderDelApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanOrderAuditApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/audit',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanOrderDetailSkuListApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/detail/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanOrderDetailSkuSpecListApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/detail/sku/spec/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanOrderDetailSkuSpecFabricListApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/detail/sku/fabric/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeWhSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/wh/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeWhWarehouseListApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/wh/warehouseList',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeWhDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/wh/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeWhDelApi(data = {}) {
    return request({
      url: '/ecom/evg/plan/order/wh/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgPlanProductionDetailApi(params = {}) {
    return request({
      url: '/ecom/evg/planproduction/detail',
      method: 'GET',
      params,
    })
  },
  evgPlanProductionSaveAndGenerateApi(data = {}) {
    return request({
      url: '/ecom/evg/planproduction/saveAndGenerateBatchPlan',
      method: 'POST',
      data,
    })
  },
  evgPlanProductionBatchGenerateApi(data = {}) {
    return request({
      url: '/ecom/evg/planproduction/batch/generate',
      method: 'POST',
      data,
    })
  },
  evgPlanProductionHolidayApi(params = {}) {
    return request({
      url: '/ecom/evg/planproduction/holiday',
      method: 'GET',
      params,
    })
  },
})
